import React from 'react';
const rebrandingSignalDiscount = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.08659 13.333L3.41992 8.66634L8.75326 3.33301H12.7533C13.1214 3.33301 13.4199 3.63148 13.4199 3.99967V7.99967L8.08659 13.333ZM11.4198 6.16634C11.88 6.16634 12.2531 5.79325 12.2531 5.33301C12.2531 4.87277 11.88 4.49967 11.4198 4.49967C10.9595 4.49967 10.5864 4.87277 10.5864 5.33301C10.5864 5.79325 10.9595 6.16634 11.4198 6.16634Z"
            fill="#324EFC"
        />
    </svg>
);
export default rebrandingSignalDiscount;
